module.exports = __webpack_public_path__ + "media/standardized_tests/colleges_icon-6d9d8870.jpg";